import * as Icons from '@mui/icons-material'; // Destructive import of all icons

const IconsMap = {
  email: Icons.Email,
  password: Icons.Lock,
};

export default IconsMap;
